import { render, staticRenderFns } from "./CatalogCategoryFiltersWrapper.vue?vue&type=template&id=2afbee49&scoped=true"
import script from "./CatalogCategoryFiltersWrapper.vue?vue&type=script&lang=js"
export * from "./CatalogCategoryFiltersWrapper.vue?vue&type=script&lang=js"
import style0 from "./CatalogCategoryFiltersWrapper.vue?vue&type=style&index=0&id=2afbee49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbee49",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcatalog-category-filters-wrapper%2FCatalogCategoryFiltersWrapper.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports